<notice-banner [notices]="notices$ | async" [dismissable]="false"></notice-banner>
<router-outlet></router-outlet>
